<p>discharge-bed works!</p>
